import { render, staticRenderFns } from "./mallHomepage.vue?vue&type=template&id=2e65f392"
import script from "./mallHomepage.vue?vue&type=script&lang=js"
export * from "./mallHomepage.vue?vue&type=script&lang=js"
import style0 from "./mallHomepage.vue?vue&type=style&index=0&id=2e65f392&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports